<script lang="ts" setup>
throw new Error('FxGradient is not supported in Phaser v4. Use the Gradient game object instead.')
</script>

<template>
  <slot />
</template>
